import { render } from "./StockManagement.vue?vue&type=template&id=356f7bb0&scoped=true"
import script from "./StockManagement.vue?vue&type=script&lang=js"
export * from "./StockManagement.vue?vue&type=script&lang=js"

import "./StockManagement.vue?vue&type=style&index=0&id=356f7bb0&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-356f7bb0"]])

export default __exports__